export class GraphValueItem {
  dateObjectId: string;
  date: Date;
  valueObjectId: string;
  value: number;

  clone(): GraphValueItem {
    const cloned = new GraphValueItem();
    cloned.dateObjectId = this.dateObjectId;
    cloned.date = this.date;
    cloned.valueObjectId = this.valueObjectId;
    cloned.value = this.value;
    return cloned;
  }
}
